import { VL_TIPOS_IDIOMA } from 'constants/App';

export default class SearchManager {
    constructor(api) {
        this.api = api;
    }

    autoCompleteSearch = (list, text, count = 10) => {
        const getParams = {
            text,
            count,
        };

        if (list === VL_TIPOS_IDIOMA) {
            getParams['fields[]'] = 'strISO639_1';
        }

        return this.api.autoCompleteSearch(list, getParams);
    };
}
